// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadPicture_button__EiNFp {
  border: none;
  width: 150px;
  height: 150px;
  position: relative;
  padding: 0;
}
.UploadPicture_button__EiNFp :hover {
  cursor: pointer;
}

.UploadPicture_imgContainer__NtPjr {
  border-radius: 50%;
}
.UploadPicture_imgContainer__NtPjr :hover {
  cursor: pointer;
}
.UploadPicture_imgContainer__NtPjr .UploadPicture_icon__838HX {
  position: absolute;
  top: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/UploadPicture/UploadPicture.module.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAFF;AAIE;EACE,eAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,eAAA;AAHJ;AAME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAJJ","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n\n.button {\n  border: none;\n  width: 150px;\n  height: 150px;\n  position: relative;\n  padding: 0;\n\n  & :hover {\n    cursor: pointer;\n  }\n}\n\n.imgContainer {\n  border-radius: 50%;\n\n  & :hover {\n    cursor: pointer;\n  }\n\n  .icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `UploadPicture_button__EiNFp`,
	"imgContainer": `UploadPicture_imgContainer__NtPjr`,
	"icon": `UploadPicture_icon__838HX`
};
export default ___CSS_LOADER_EXPORT___;
